import { ThunkAction } from 'redux-thunk';
import {
    supportFilterSuccess
} from '../../actions/load-cases';
import { ICase, ISearchFilter } from '@telstra-connect/channel-care/state/cases';
import { IChannelCareAppState } from '@telstra-connect/channel-care/state/index';

/**
 * This thunk action updates the support filters in the Redux store based on the provided cases.
 * It formats the filters for "submitted by" and "assigned to" fields and dispatches the updated filters.
 *
 * @param data - An array of case objects used to derive the support filters.
 *
 * @Behavior
 * - It invokes helper functions `formatFilterSubmittedBy` and `formatFilterAssignedTo` to extract unique
 * values for "submitted by" and "assigned to" from the provided cases.
 * - The resulting filter objects are merged and dispatched using `supportFilterSuccess`.
 */
export function updateSupportFilter(
    data: ICase[],
    shouldUpdateSupportFilter: boolean,
    existingSupportFilters: ISearchFilter
): ThunkAction<void, IChannelCareAppState, void> {
    return (dispatch, getState) => {
        const supportFilters = shouldUpdateSupportFilter
            ? {
                ...formatFilterSubmittedBy(data),
                ...formatFilterAssignedTo(data),
            }
            : existingSupportFilters;
        dispatch(supportFilterSuccess(supportFilters));
    };
}

function formatFilterSubmittedBy(cases: ICase[]): ISearchFilter {
    const submittedBy = new Set<string>();
    cases.forEach((element) => element && submittedBy.add(element.submittedBy));
    const response: ISearchFilter = {
        submittedBy: Array.from(submittedBy)
    }
    return response
}

function formatFilterAssignedTo(cases: ICase[]): ISearchFilter {
    const assignedTo = new Set<string>();
    cases.forEach((element) => element && assignedTo.add(element.subStatus));
    const response: ISearchFilter = {
        assignedTo: Array.from(assignedTo)
    }
    return response;
}
